import styled from '@emotion/styled';

export const ImageContainer = styled.div`
  width: 100%;
  border-bottom: 9px solid ${({ theme }) => theme.colors.primaryBlue};
`;

export const HeroPicture = styled.picture`
  display: block;
  width: 100%;
`;

export const HeroImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export const Content = styled.div`
  padding: 25px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Title = styled.div`
  font-family: NokiaPureHeadline-Light;
  font-size: 30px;
  color: ${({ theme }) => theme.colors.grey900};
  line-height: 36px;
`;

export const AuthorLine = styled.div`
  font-family: NokiaPureHeadline-Regular;
  color: ${({ theme }) => theme.colors.grey900};
  font-size: 14px;
  line-height: 24px;
`;

export const Author = styled.span`
  font-family: NokiaPureHeadline-Regular;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grey900};
`;

export const ClickableAuthor = styled.span`
  font-family: NokiaPureHeadline-Regular;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.primaryBlue};
  border-bottom: 1px solid ${({ theme }) => theme.colors.primaryBlue};
`;

export const Date = styled(AuthorLine)``;

export const NewsContent = styled.div`
  font-size: 16px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.grey900};
`;
